// strings, floats
export default (h, field, errorMessages, value, onInput, onBlur, onFocus, self) => {
  console.log('Combobox')
  console.log('self', self)
  console.log('this: ', this)
  const items = field.values || self.$store.getters[field.source]
  console.log('items: ', items)
  if (!items.length && field.fetch) self.$store.dispatch(field.fetch)

  return (
    <v-combobox
      label={field.attributes.label}
      value={value}
      items={items}
      errorMessages={errorMessages}
      onInput={onInput}
      onChange={onInput}
      itemText={field.attributes.itemText}
      itemValue={field.attributes.itemValue}
      class={field.attributes.class}
      clearable
      dense
    >
    </v-combobox>
  )
}
